
import Vue from 'vue';
import type { VueConstructor } from 'vue';
import formHelper from '@/mixins/formHelper';

export default (Vue as VueConstructor<Vue & InstanceType<typeof formHelper>>).extend({
	name: 'PasswordForm',

	mixins: [formHelper],

	props: {
		password: {
			type: String,
			required: true
		},
		passwordConf: {
			type: String,
			default: ''
		},
		isFocused: {
			type: Boolean,
			default: false
		},
		isSinglePassInput: {
			type: Boolean,
			default: false
		},
		isDense: {
			type: Boolean,
			default: true
		},
		passwordRequirements: {
			type: Array<{ label: any; isValid: boolean }>,
			default: () => []
		},
		samePasswordValidation: {
			type: [String, Boolean],
			default: false
		}
	},

	methods: {
		handleKeydown(event: KeyboardEvent) {
			if (event.code === 'Space' || event.key === ' ') {
				event.preventDefault();
			}
		}
	}
});
